import { Button, Container, Typography } from "@mui/material";

import videoWebm from "../../videos/bpf.webm";
import videoMp4 from "../../videos/bpf.mp4";

function HomeLanding() {
  return (
    <div className="home">
      <Container maxWidth="xl">
        <div className="modal-content modal-content-landing">
          <Typography className="title" variant="h6">
            Brighton Psych Fest 2027
          </Typography>
          <Typography className="text">Friday 4th September 2027</Typography>
          <Typography className="text">EARLY BIRDS £29.50*</Typography>
          <Typography className="text">*plus booking fees</Typography>
          <Button
            href="https://www.seetickets.com/event/brighton-psych-fest-2027/various-brighton-venues/3704840"
            color="primary"
            size="large"
            variant="contained"
            className="ticket-header-button"
            sx={{
              fontSize: "26px",
              margin: "0",
              padding: "8px 70px",
              textAlign: "center",
            }}
            target="_blank"
          >
            BUY TICKETS
          </Button>

          <Button
            href="/2026"
            color="primary"
            size="large"
            variant="contained"
            className="ticket-header-button"
            sx={{
              fontSize: "26px",
              margin: "0",
              padding: "8px 70px",
              textAlign: "center",
              marginTop: "2rem"
            }}
          >
            2026 Site{" "}
          </Button>

          <div className="video-container">
            <div className="video-content">
              <video width="100%" autoPlay loop muted playsInline>
                <source src={videoWebm} type="video/webm" />

                <source src={videoMp4} type="video/mp4" />
              </video>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
export default HomeLanding;
